/* eslint-disable no-magic-numbers */
export const emiNumberFormat = value => {
    if (value === null || value === undefined) {
        return '';
    }

    const absValue = Math.abs(value);

    let formattedValue;
    let abbreviation = '';

    if (absValue < 1000) {
        formattedValue = Math.floor(value);
        abbreviation = '';
    }
    else if (absValue < 1000000) {
        formattedValue = Math.floor(value / 100) / 10;
        abbreviation = 'rb';
    }
    else if (absValue < 1000000000) {
        formattedValue = Math.floor(value / 100000) / 10;
        abbreviation = 'jt';
    }
    else if (absValue < 1000000000000) {
        formattedValue = Math.floor(value / 100000000) / 10;
        abbreviation = 'm';
    }
    else {
        formattedValue = Math.floor(value / 100000000000) / 10;
        abbreviation = 't';
    }

    let decimalFormatted = formattedValue.toFixed(1);

    if (decimalFormatted.endsWith('.0')) {
        decimalFormatted = decimalFormatted.slice(0, -2); // Remove ".0"
    }

    // Handle negative sign for values >= 1000 after formatting
    let prefix = '';

    if (value < 0 && absValue >= 1000) {
        prefix = '-';
    }

    return `${prefix}${decimalFormatted}${abbreviation ? ` ${abbreviation}` : ''}`;
};
